import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const fazendaReducer = (state = InitialState.fazendaReducer, action) => {
    switch (action.type) {
        case ActionType.GET_FAZENDA_RESPONSE: {
            return {
                ...state,
                fazendaObject: _.assign(action.fazendaObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default fazendaReducer;